"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useA11yIdPrefix = void 0;

var react_1 = require("react");

var idCounter = 0;

var useA11yIdPrefix = function useA11yIdPrefix(text) {
  return react_1.useState(function () {
    return "zora-a11y-".concat(idCounter++, "-").concat(text);
  })[0];
};

exports.useA11yIdPrefix = useA11yIdPrefix;